import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "7364673c-0e0b-419d-90b9-38a196ff6d34",
    content: "Answer A",
    options: {
      image: `${config.ASSETS_URL}/04/11/task/task-3-answer-a.svg`,
    },
  },
  {
    id: "3eceeb0f-f812-4adc-87f0-7ecfb5a45e4b",
    content: "Answer B",
    options: {
      image: `${config.ASSETS_URL}/04/11/task/task-3-answer-b.svg`,
    },
  },
  {
    id: "262b5ab0-b0ad-4133-8d5f-13a19fe3f385",
    content: "Answer C",
    options: {
      image: `${config.ASSETS_URL}/04/11/task/task-3-answer-c.svg`,
    },
  },
  {
    id: "66322203-34a6-4ff0-bd9c-7f2e5ded0960",
    content: "Answer D",
    options: {
      image: `${config.ASSETS_URL}/04/11/task/task-3-answer-d.svg`,
    },
  },
];

export const task: Task = {
  id: "1b0c7c06-bbf8-4ffc-9c47-7cfbefcdbd19",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["3eceeb0f-f812-4adc-87f0-7ecfb5a45e4b"],
};
